import { SvgIcon, SxProps, Theme } from "@mui/material";
import { ReactElement } from "react";
export default function AgentAssistSvg({
    sx,
    ...rest
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    return (
        <SvgIcon
            viewBox="0 0 18 18"
            sx={{
                width: "18",
                height: "18",
                fill: "none",
                ...sx,
            }}
            {...rest}
        >
            <mask x="0" y="0" width="18" height="18">
                <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g>
                <path
                    d="M13.7727 8.9735C13.7727 6.34229 11.6316 4.20117 9.00035 4.20117C6.36914 4.20117 4.22803 6.34229 4.22803 8.9735C4.22803 11.6047 6.36914 13.7458 9.00035 13.7458C11.6316 13.7458 13.7727 11.6053 13.7727 8.9735Z"
                    fill="#6699FF"
                />
                <path
                    d="M15.8841 6.62239H15.5576C14.5685 3.85014 11.9634 2 9.0003 2C6.03722 2 3.43268 3.85014 2.44302 6.62239H2.11649C1.50076 6.62239 1 7.12315 1 7.73888V10.2071C1 10.8228 1.50076 11.3242 2.11649 11.3242H3.3509C3.51446 11.3242 3.64721 11.1915 3.64721 11.0279V6.9187C3.64721 6.75514 3.51446 6.62239 3.3509 6.62239H3.07415C4.03004 4.19682 6.36079 2.59261 9.0003 2.59261C11.6398 2.59261 13.9706 4.19682 14.9264 6.62239H14.6497C14.4861 6.62239 14.3534 6.75514 14.3534 6.9187V11.0279C14.3534 11.1915 14.4861 11.3242 14.6497 11.3242H14.9116C14.0932 13.3847 12.2496 14.8834 10.0593 15.252C9.89752 14.8224 9.48565 14.5148 9.0003 14.5148C8.3745 14.5148 7.86544 15.0239 7.86544 15.6497C7.86544 16.2755 8.3745 16.7845 9.0003 16.7845C9.55676 16.7845 10.0184 16.3816 10.1144 15.8524C12.6075 15.45 14.706 13.7053 15.5576 11.3236H15.8835C16.4992 11.3236 17 10.8223 17 10.2065V7.73888C17.0006 7.12315 16.4998 6.62239 15.8841 6.62239Z"
                    fill="#333333"
                />
            </g>
        </SvgIcon>
    );
}
